import { UniversalProduct } from '@1po/1po-bff-fe-spec/generated/catalog/universal_products/response/GetUniversalProductsResponse';
import { minBulkChunkValue } from 'components/QuantityModule/QuantityModule';
import { ReferenceLocal } from 'domains/basket/Basket.types';
import {
  CERTAS_OIL_1000L_NAME,
  CERTAS_OIL_208L_NAME,
  CERTAS_OIL_BULK_NAME,
  CERTAS_OIL_FAMILY_CODE,
  CERTAS_OIL_PRODUCT_MODEL_CODE,
} from 'domains/catalog/Catalog.types';
import { DHReferenceLocal } from 'domains/references';

export function isCertasOil(familyCode?: string, productModelCode?: string): boolean {
  return familyCode === CERTAS_OIL_FAMILY_CODE || productModelCode === CERTAS_OIL_PRODUCT_MODEL_CODE;
}

export function isDrumCertasOil(familyCode?: string, productModelCode?: string, productName?: string): boolean {
  return (
    isCertasOil(familyCode, productModelCode) &&
    ((productName ?? '').toUpperCase().includes(CERTAS_OIL_208L_NAME) ||
      (productName ?? '').toUpperCase().includes(CERTAS_OIL_1000L_NAME))
  );
}

export function isBulkCertasOil(familyCode?: string, productModelCode?: string, productName?: string): boolean {
  return isCertasOil(familyCode, productModelCode) && (productName ?? '').toUpperCase().includes(CERTAS_OIL_BULK_NAME);
}

export function isCanCertasOil(familyCode?: string, productModelCode?: string, productName?: string): boolean {
  return (
    isCertasOil(familyCode, productModelCode) &&
    !isDrumCertasOil(familyCode, productModelCode, productName) &&
    !isBulkCertasOil(familyCode, productModelCode, productName)
  );
}

export function isNonBulkCertasOil(familyCode?: string, productModelCode?: string, productName?: string): boolean {
  return isCertasOil(familyCode, productModelCode) && !(productName ?? '').toUpperCase().includes(CERTAS_OIL_BULK_NAME);
}

export function getOilVolumeLiters(reference: ReferenceLocal | undefined): number {
  const volumeLiters = reference?.packaging ?? '0L';
  return parseInt(volumeLiters.replace('L', ''), 10) || 0;
}

export function getOilChunk(reference: ReferenceLocal | undefined, fallbackChunk?: string): number {
  if (reference?.packaging?.toUpperCase().includes(CERTAS_OIL_BULK_NAME)) {
    return minBulkChunkValue;
  } else {
    return Number.parseInt(reference?.chunk ?? fallbackChunk ?? '1', 10);
  }
}

export const getTechnicalCharacteristicsValue = (
  refData: DHReferenceLocal | undefined,
  code: string,
): string | undefined => {
  const technicalCharacteristics = refData?.characteristics?.technicalCharacteristics ?? [];
  return technicalCharacteristics.find((item) => item?.codeTechnicalCharacteristic === code)?.value;
};

export const getTechnicalCharacteristicsLabel = (
  refData: DHReferenceLocal | undefined,
  code: string,
): string | undefined => {
  const technicalCharacteristics = refData?.characteristics?.technicalCharacteristics ?? [];
  return technicalCharacteristics.find((item) => item?.codeTechnicalCharacteristic === code)?.label;
};

export const getUniversalProductTechnicalCharacteristicsLabel = (
  refData: UniversalProduct | undefined,
  code: string,
): string | undefined => {
  const technicalCharacteristics = refData?.technicalCharacteristics ?? [];
  return technicalCharacteristics.find((item) => item?.codeTechnicalCharacteristic === code)?.label;
};
